import script from "./index-web.vue?vue&type=script&setup=true&lang=ts"
export * from "./index-web.vue?vue&type=script&setup=true&lang=ts"

import "./index-web.vue?vue&type=style&index=0&id=d0e3c1f4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0e3c1f4"]])

export default __exports__